var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/marketplace/marketplace-seller-info.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if((lineno = 0, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.sellerInfo.shopName"]))) {
output += "\n\n    <div class=\"c-marketplace-meta__seller\" data-qa-marketplace-meta-seller>\n                \n        <span class=\"c-marketplace-meta__seller-label\" data-qa-marketplace-meta-seller-label>";
output += runtime.suppressValue((lineno = 4, colno = 95, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace-fulfilled_by"])), env.opts.autoescape);
output += "</span>\n\n        <span class=\"c-marketplace-meta__seller-name\" data-qa-marketplace-meta-seller-name>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"sellerInfo")),"shopName"), env.opts.autoescape);
output += "</span>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/marketplace/marketplace-seller-info.j2"] , dependencies)